
import { defineComponent, onMounted, getCurrentInstance, computed, onUnmounted } from 'vue';
import cookies from 'js-cookie';
import AIFeedComponent from './components/ai-feed/ai-feed.vue';
import AIBaseLayout from './components/ai-base-layout/index.vue';
// import { autoLaunchAppWarp } from '@/common/call-app';
import { immediateSendLog, reportFMP } from '@/common/radar';
import { extractTitleFromMetaInfo, header } from '@/common/seo';
import { setCommonParamsCookiesInServer } from '@/common/common-params';
import { AIFeedPageEnum } from '@/store/modules/ai-feed';
import { ComponentNameMap } from '@/constants/base';
import { AIFeed } from '~/api/ai-feed';
import { SEOApi } from '~/api/seo';
import { commonPvParams } from '~/common/utils';
import useAppEnvironment from './hooks/useAppEnvironment';

const AIForyou = defineComponent({
    name: ComponentNameMap.AIForyou,
    components: {
        AIFeedComponent,
        AIBaseLayout,
    },
    layout(ctx) {
        return ctx.$pwaLayout || 'default';
    },
    setup() {
        const { proxy } = getCurrentInstance() || {};
        const { isIOS, isAppEnvironment } = useAppEnvironment();
        const feedList = computed<AIFeed[]>(() => {
            const { feedListOrigin } = proxy?.$store?.state?.aiFeedMoudle || {};
            return feedListOrigin?.[AIFeedPageEnum.AIForyou] || [];
        });

        const sendPv = () => {
            const params = commonPvParams({ defaultPageSource: 'aichat' });
            const country = proxy?.$store?.state?.startup?.countryInfo;
            const user_id = cookies.get('user_id');
            immediateSendLog({
                type: 'pv',
                name: 'AI_FRIENDS_PAGE',
                value: {
                    country,
                    user_id,
                    ...params,
                    ...proxy?.$route.query,
                },
            });
        };

        onMounted(async () => {
            reportFMP();
            sendPv();

            (window as any).customNuxtEnv = {
                BUSINESS_ENV: process.env.BUSINESS_ENV,
                NODE_ENV: process.env.NODE_ENV,
            };
        });
        return {
            AIFeedPageEnum,
            isIOS,
            isAppEnvironment,
        };
    },

    async asyncData(ctx) {
        if (process.server) {
            const { startup } = ctx?.store?.state || {};
            setCommonParamsCookiesInServer({
                ctx,
                bucket: startup?.bucket,
                host: ctx.req.headers.host,
                countryInfo: startup?.countryInfo,
            });

            const isWeeeye = ctx?.$isWeeeye;
            const isFantasay = ctx?.$isFantasay;
            const { pwa_source } = ctx?.route?.query || {};
            if (isWeeeye || isFantasay || pwa_source === 'aichat_test') {
                const url = `https://${ctx?.req?.headers?.host}${ctx?.route?.path}` || '';
                const tdkPromise = SEOApi.getTDKLdJson({ url, needTdk: true });
                const res = await tdkPromise;
                return {
                    metaInfoData: res?.data?.tdk || [],
                    title: extractTitleFromMetaInfo({
                        ctx,
                        metaInfoData: res?.data?.tdk || [],
                    }),
                };
            }
        }

        return {
            metaInfoData: [],
        };
    },

    head() {
        const head = header(this);
        return head;
    },
});

export default AIForyou;
